import React from 'react';
import type { TableBodyProps } from '@mui/material';
import { TableHead as MuiTableHead } from '@mui/material';
import { css } from '@emotion/react';

const TableHead: React.FC<TableBodyProps> = props => (
    <MuiTableHead css={css(`th {border: none}`)} {...props} />
);

export default TableHead;
